import type { NotificationOptimisticReadList } from "./notification-optimistic-read.type";
import type { NotificationEntity } from "@/entities/notification";

import { atom } from "jotai";

export const notificationOptimisticReadListAtom =
  atom<NotificationOptimisticReadList>([]);

export const addToOptimisticListAtom = atom(
  null,
  (get, set, notifId: NotificationEntity["id"]) => {
    const currentList = get(notificationOptimisticReadListAtom);
    set(notificationOptimisticReadListAtom, [...currentList, notifId]);
  }
);

export const removeFromOptimisticListAtom = atom(
  null,
  (get, set, notifId: NotificationEntity["id"]) => {
    const currentList = get(notificationOptimisticReadListAtom);
    const newList = currentList.filter((id) => id !== notifId);
    set(notificationOptimisticReadListAtom, newList);
  }
);
